"use client"

import { useState, useEffect, useMemo } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import imageCompression from "browser-image-compression";

import {
    FiTag,
    FiMonitor,
    FiCalendar,
    FiMapPin,
    FiLink,
    FiDollarSign,
    FiPlus,
    FiEdit3,
    FiTrash2,
    FiCheck,
    FiUsers,
    FiX,
    FiUpload,
    FiFilter,
    FiSearch,
    FiChevronRight,
    FiChevronLeft,
} from "react-icons/fi"
import { createForum, deleteForum, fetchTactosEvents, getAllForums, removeComment, tactosCreateEvent, tactosDeleteEvent, tactosUpdateEvent, updateForum, updateForumStatus } from "../utils/api"
import { useQuery } from "@tanstack/react-query"
import { Check, Eye, MessageSquare, X } from "lucide-react"
import { toast } from "react-toastify"
import moment from "moment"
const isEventNew = (createdAt) => {
    if (!createdAt) return false;
    const eventDate = new Date(createdAt);
    const now = new Date();
    const diffInHours = (now - eventDate) / (1000 * 60 * 60);
    return diffInHours <= 24;
};

const AdminEventCardSkeleton = () => {
    return (
        <div className="bg-white rounded-3xl p-6 animate-pulse">
            <div className="flex items-start gap-4 mb-4">
                <div className="w-16 h-16 rounded-2xl bg-gray-200" />
                <div className="flex-1 space-y-2">
                    <div className="h-4 w-1/2 bg-gray-200 rounded" />
                    <div className="h-3 w-2/3 bg-gray-200 rounded" />
                </div>
            </div>

            <div className="space-y-3 mb-4">
                <div className="h-3 w-full bg-gray-200 rounded" />
                <div className="h-3 w-5/6 bg-gray-200 rounded" />
                <div className="h-3 w-4/6 bg-gray-200 rounded" />
            </div>

            <div className="flex gap-2">
                <div className="h-8 w-20 bg-gray-200 rounded-lg" />
                <div className="h-8 w-20 bg-gray-200 rounded-lg" />
                <div className="h-8 w-24 bg-gray-200 rounded-lg" />
            </div>
        </div>
    );
};

const AdminForum = () => {
    const [activeTab, setActiveTab] = useState("Free")
    const [events, setEvents] = useState([])
    const [showForm, setShowForm] = useState(false)
    const [showFieldModal, setShowFieldModal] = useState(false);
    const [newField, setNewField] = useState({ label: "", type: "text", required: false, for: "" });
    const [loader, setLoader] = useState(false)

    const [formData, setFormData] = useState({
        title: "",
        description: "",
        images: []

    })


    const [editIndex, setEditIndex] = useState(null)
    const navigate = useNavigate()

    // useEffect(() => {
    //   fetchEvents()
    // }, [])

    // const fetchEvents = async () => {
    //   const res = await fetchTactosEvents()
    //   console.log(res)
    //   setEvents(res)
    // }
    const [filters, setFilters] = useState({
        name: "",
        location: "",
        startDate: "",
        mode: "",
    });
    const [page, setPage] = useState(1);
    const { data: forums, isLoading, refetch } = useQuery({
        queryKey: ['forums'],
        queryFn: getAllForums
    })

    useEffect(() => {
        console.log(forums)
    }, [forums])


    const handleTabChange = (tab) => setActiveTab(tab)

    const handleInputChange = (e) => {
        const { name, value } = e.target
        setFormData({ ...formData, [name]: value })
    }

    const handleViewRegistration = (eventId) => {
        navigate(`/admin/registrations/${eventId}`)
    }

    const handleFormSubmit = async (e) => {
        e.preventDefault();


        try {
            if (

                !formData.title ||
                !formData.description

            ) {
                alert("Please fill all required fields including the form.");
                return;
            }

            setLoader(true)

            if (editIndex) {
                console.log(formData)
                const res = await updateForum(formData._id, formData)
                console.log(res)
            } else {
                await createForum(formData);
            }




            refetch()
            setShowForm(false);
            setFormData({
                ...formData,
                title: "",
                description: ""
            })

            setEditIndex(null);
        } catch (err) {
            if (err.status == 401) {
                localStorage.clear()
                toast.error("Session expired. Please login again.");
                navigate("/login")
            }
            console.error("Form submit failed:", err);
        } finally {
            setLoader(false)
        }
    };
    const handleForumStatusUpdate = async (data, status) => {

        try {
            let payload = { status: status }
            const res = await updateForumStatus(data._id, payload)

            refetch()
            toast.success(res.message)

            setEditIndex(null);
        } catch (err) {
            if (err.status == 401) {
                toast.error("Session expired. Please login again.");
                navigate("/login")
                localStorage.clear()
            }
            console.error("Form submit failed:", err);
        }
    };


    const handleView = (forum) => {
        console.log(forum);


        setFormData(forum);
        setEditIndex(forum._id);
        setShowForm(true);
    };


    const handleChange = async (e) => {
        const { name, type, checked, files, value } = e.target;

        if (name === "logo" && files?.length > 0) {
            let file = files[0];

            // Fix WhatsApp .jpe files
            if (file.name.endsWith(".jpe")) {
                file = new File([file], file.name.replace(".jpe", ".jpg"), {
                    type: "image/jpeg"
                });
            }

            // 🔥 FRONTEND FIX: COMPRESS BEFORE BASE64
            try {
                const compressedFile = await imageCompression(file, {
                    maxSizeMB: 0.4,            // Keep base64 under Cloudflare’s limit
                    maxWidthOrHeight: 1600,    // Resize large images
                    useWebWorker: true
                });

                readFileAsBase64(compressedFile);
            } catch (err) {
                console.error("Image compression failed:", err);
            }

            return;
        }

        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };


    const readFileAsBase64 = (files) => {
        const fileArray = Array.from(files);

        // ⛔ limit check
        if (formData.images.length + fileArray.length > 3) {
            alert("You can upload only 3 images");
            return;
        }

        fileArray.forEach((file) => {
            const reader = new FileReader();

            reader.onloadend = () => {
                setFormData((prev) => ({
                    ...prev,
                    images: [...prev.images, reader.result]
                }));
            };

            reader.readAsDataURL(file);
        });
    };



    const handleRemoveComment = async (commentId, forum) => {
        try {
            const responce = await removeComment(forum._id, commentId)
            toast.success(responce.message)
            setFormData({
                ...formData,
                title: "",
                description: ""
            }),
                setShowForm(true)
            refetch()
        } catch (error) {
            if(error?.response?.status==401){
                toast.error("Session expired please login again.")
                localStorage.clear()
                window.location.href='/login'
            }
            toast.error(error.response.data.message)
            console.error("Form submit failed:", err);
        }
    }







    const tabVariants = {
        inactive: { scale: 1, opacity: 0.7 },
        active: { scale: 1.05, opacity: 1 },
    }

    const cardVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0 },
        hover: { y: -5, scale: 1.02 },
    }

    const onModalOpenForFields = (data) => {
        setNewField({})
        console.log(data)
        setShowFieldModal(true);
        setNewField({ ...newField, for: data })

    }

    const onDelete = async (forum) => {
        try {
            await deleteForum(forum._id)
        refetch()
        } catch (error) {
            if(error?.response?.status==401){
                toast.error("Session expired please login again.")
                localStorage.clear()
                window.location.href='/login'
            }
        }
    }

    useEffect(() => {
        // console.log(modeDetails)
        console.log(events)
    }, [events])
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 p-4 sm:p-6 lg:p-8">
            <div className="max-w-7xl mx-auto space-y-8">
                {/* Header Section */}
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="bg-white rounded-3xl p-6"
                >
                    <div className="flex flex-col lg:flex-row justify-between items-center gap-6">
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl flex items-center justify-center">
                                <FiCalendar className="text-white text-xl" />
                            </div>
                            <div>
                                <h1 className="text-3xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent">
                                    Forum Management
                                </h1>
                                <p className="text-gray-500 text-sm">
                                    Review, approve, and manage community forum submissions
                                </p>
                            </div>

                        </div>

                        <div className="flex items-center gap-4">
                            <motion.button
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                onClick={() => {
                                    setFormData({
                                        ...formData,
                                        title: "",
                                        description: ""
                                    }),
                                        setShowForm(true)
                                }}
                                className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-3 rounded-xl font-semibold flex items-center gap-2"
                            >
                                <FiPlus className="text-lg" />
                                Add New Forum
                            </motion.button>
                        </div>
                    </div>
                </motion.div>



                {/* Events Grid */}
                <motion.div layout className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                    <AnimatePresence>
                        {isLoading ? Array.from({ length: 1 }).map((_, index) => (
                            <motion.div
                                key={`skeleton-${index}`}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                            >
                                <AdminEventCardSkeleton />
                            </motion.div>
                        )) : forums?.data?.map((forum, index) => (
                            <motion.div
                                key={forum._id}
                                variants={cardVariants}
                                initial="hidden"
                                animate="visible"
                                exit="hidden"
                                whileHover="hover"
                                transition={{ delay: index * 0.1 }}
                                className="group relative bg-white rounded-3xl p-6 shadow-md 
             hover:shadow-2xl transition-all duration-300
             border border-gray-100 overflow-hidden"
                            >
                                {/* Hover Glow Effect */}
                                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-300 
                  bg-gradient-to-br from-indigo-50 via-transparent to-purple-50" />

                                {/* Status Badge */}
                                <div className="absolute top-4 right-4 z-20">
                                    <span
                                        className={`px-3 py-1 text-xs font-semibold rounded-full border
        ${forum.status === "approved"
                                                ? "bg-emerald-100 text-emerald-700 border-emerald-200"
                                                : forum.status === "rejected"
                                                    ? "bg-red-100 text-red-700 border-red-200"
                                                    : "bg-amber-100 text-amber-700 border-amber-200"
                                            }`}
                                    >
                                        {forum.status.toUpperCase()}
                                    </span>
                                </div>

                                {/* Header */}
                                <div className="relative z-10 flex items-start gap-4 mb-5 mt-4">
                                    {/* Icon */}
                                    <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 
                    flex items-center justify-center flex-shrink-0 shadow-lg">
                                        <MessageSquare className="text-white text-2xl" />
                                    </div>

                                    {/* Title + Startup Name */}
                                    <div className="flex-1 min-w-0">
                                        <h3 className="text-lg font-bold text-gray-900 truncate">
                                            {forum.title}
                                        </h3>

                                        {/* Startup Name */}
                                        <p className="text-sm font-medium text-indigo-600 truncate">
                                            {forum?.startupId?.startupName || "Tactos"}
                                        </p>

                                        <p className="text-xs text-gray-400 mt-1">
                                            Created on {moment(forum.createdAt).format("DD/MM/YYYY")}
                                        </p>
                                    </div>
                                </div>

                                {/* Description */}
                                <div className="relative z-10 mb-6">
                                    <p className="text-sm text-gray-600 leading-relaxed line-clamp-3">
                                        {forum.description}
                                    </p>
                                </div>

                                {/* Actions */}
                                <div className="relative z-10 flex items-center gap-3 pt-3 border-t border-gray-100">

                                    {/* LEFT ACTIONS */}
                                    <div className="flex gap-2">
                                        <motion.button
                                            whileHover={{ scale: 1.05 }}
                                            whileTap={{ scale: 0.95 }}
                                            onClick={() => handleView(forum)}
                                            className="flex items-center gap-1 bg-indigo-600 hover:bg-indigo-700 
                 text-white px-4 py-2 rounded-lg text-xs font-medium"
                                        >
                                            <Eye size={14} />
                                            View
                                        </motion.button>

                                        {forum?.status !== "approved" && forum?.status !== "rejected" && (
                                            <>
                                                <motion.button
                                                    whileHover={{ scale: 1.05 }}
                                                    whileTap={{ scale: 0.95 }}
                                                    onClick={() => handleForumStatusUpdate(forum, "approved")}
                                                    className="flex items-center gap-1 bg-emerald-600 hover:bg-emerald-700 
                     text-white px-4 py-2 rounded-lg text-xs font-medium"
                                                >
                                                    <Check size={14} />
                                                    Approve
                                                </motion.button>

                                                <motion.button
                                                    whileHover={{ scale: 1.05 }}
                                                    whileTap={{ scale: 0.95 }}
                                                    onClick={() => handleForumStatusUpdate(forum, "rejected")}
                                                    className="flex items-center gap-1 bg-orange-500 hover:bg-orange-600 
                     text-white px-4 py-2 rounded-lg text-xs font-medium"
                                                >
                                                    <X size={14} />
                                                    Reject
                                                </motion.button>
                                            </>
                                        )}
                                    </div>

                                    {/* RIGHT ACTION */}
                                    <motion.button
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.95 }}
                                        onClick={() => onDelete(forum)}
                                        className="flex items-center gap-1 bg-red-500 hover:bg-red-600 
               text-white px-4 py-2 rounded-lg text-xs font-medium"
                                    >
                                        <FiTrash2 size={14} />
                                        Delete
                                    </motion.button>
                                </div>

                            </motion.div>


                        ))}
                    </AnimatePresence>
                </motion.div>

                {/* Empty State */}
                {!isLoading && forums?.data?.length === 0 && (
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className="text-center py-16"
                    >
                        <div className="w-24 h-24 bg-gradient-to-br from-gray-100 to-gray-200 rounded-3xl flex items-center justify-center mx-auto mb-6">
                            <FiCalendar className="text-gray-400 text-3xl" />
                        </div>
                        <h3 className="text-xl font-semibold text-gray-700 mb-2">No Forums found</h3>
                        <p className="text-gray-500 mb-6">Looks empty here. Create your first forum to begin.</p>
                        <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => setShowForm(true)}
                            className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-3 rounded-xl font-semibold"
                        >
                            Create Event
                        </motion.button>
                    </motion.div>
                )}

                {events?.pagination?.totalPages > 1 && (
                    <div className="flex justify-center items-center gap-6 mt-10">

                        {/* PREVIOUS */}
                        <motion.button
                            whileHover={page !== 1 ? { scale: 1.06 } : {}}
                            whileTap={page !== 1 ? { scale: 0.94 } : {}}
                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                            disabled={page === 1}
                            onClick={() => setPage(p => p - 1)}
                            className={`
        px-5 py-2 rounded-full
        font-semibold flex items-center gap-1
        border transition-all duration-200
        ${page === 1
                                    ? "border-gray-300 text-gray-400 cursor-not-allowed"
                                    : "border-black text-black  hover:bg-gradient-to-r from-blue-600 to-purple-600 hover:text-white hover:border-none"
                                }
      `}
                        >
                            <FiChevronLeft className="text-lg" />
                            Prev
                        </motion.button>

                        {/* PAGE INDICATOR */}
                        <motion.div
                            initial={{ scale: 0.9, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ duration: 0.3, ease: "easeOut" }}
                            className="
        px-6 py-2 rounded-full
       bg-gradient-to-r from-blue-600 to-purple-600
        text-white font-bold tracking-wide
        shadow-lg
      "
                        >
                            Page {events.pagination.currentPage} / {events.pagination.totalPages}
                        </motion.div>

                        {/* NEXT */}
                        <motion.button
                            whileHover={page !== events.pagination.totalPages ? { scale: 1.06 } : {}}
                            whileTap={page !== events.pagination.totalPages ? { scale: 0.94 } : {}}
                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                            disabled={page === events.pagination.totalPages}
                            onClick={() => setPage(p => p + 1)}
                            className={`
        px-5 py-2 rounded-full
        font-semibold flex items-center gap-1
        border transition-all duration-200
        ${page === events.pagination.totalPages
                                    ? "border-gray-300 text-gray-400 cursor-not-allowed"
                                    : "border-black text-black hover:bg-gradient-to-r from-blue-600 to-purple-600 hover:text-white hover:border-none "
                                }
      `}
                        >
                            Next
                            <FiChevronRight className="text-lg" />
                        </motion.button>

                    </div>
                )}

            </div>

            {/* Form Modal  Event Adding*/}
            <AnimatePresence>
                {showForm && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
                    >
                        <motion.div
                            initial={{ opacity: 0, scale: 0.9, y: 20 }}
                            animate={{ opacity: 1, scale: 1, y: 0 }}
                            exit={{ opacity: 0, scale: 0.9, y: 20 }}
                            className="bg-white rounded-3xl w-full max-w-4xl max-h-[90vh] overflow-auto"
                        >
                            <div className="sticky top-0 bg-white border-b border-gray-100 p-6 rounded-t-3xl">
                                <div className="flex items-center justify-between">
                                    <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent">
                                        {editIndex !== null ? "Edit Forum" : "Create A New Forum"}
                                    </h2>
                                    <motion.button
                                        whileHover={{ scale: 1.1, rotate: 90 }}
                                        whileTap={{ scale: 0.9 }}
                                        onClick={() => {
                                            setShowForm(false)
                                            setEditIndex(null)
                                        }}
                                        className="w-10 h-10 bg-gray-100 hover:bg-red-100 rounded-full flex items-center justify-center transition-colors duration-300"
                                    >
                                        <FiX className="text-gray-600 hover:text-red-600" />
                                    </motion.button>
                                </div>
                            </div>

                            <form onSubmit={handleFormSubmit} className="p-6">
                                <div className="grid grid-cols-1 gap-6">

                                    {/* Title */}
                                    <div className="space-y-2">
                                        <label className="text-sm font-semibold text-gray-700">
                                            Title <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="title"
                                            value={formData.title}
                                            onChange={handleInputChange}
                                            placeholder="Enter forum title"
                                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl
                   focus:outline-none focus:ring-2 focus:ring-blue-500/20
                   focus:border-blue-500 transition-all duration-300"
                                            required
                                        />
                                    </div>

                                    {/* Description */}
                                    <div className="space-y-2">
                                        <label className="text-sm font-semibold text-gray-700">
                                            Description <span className="text-red-500">*</span>
                                        </label>
                                        <textarea
                                            name="description"
                                            value={formData.description}
                                            onChange={handleInputChange}
                                            placeholder="Enter forum description"
                                            rows={5}
                                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl
                   focus:outline-none focus:ring-2 focus:ring-blue-500/20
                   focus:border-blue-500 transition-all duration-300 resize-none"
                                            required
                                        />
                                    </div>

                                    {/* Images Upload */}
                                    {/* Image Upload Box */}
                                    <div
                                        className="border-2 border-dashed border-gray-300 rounded-xl p-8 text-center
             hover:border-blue-400 transition cursor-pointer"
                                        onDragOver={(e) => e.preventDefault()}
                                        onDrop={(e) => {
                                            e.preventDefault();
                                            readFileAsBase64(e.dataTransfer.files);
                                        }}
                                    >
                                        <p className="text-gray-600 mb-2">
                                            Drag and drop or upload images
                                        </p>

                                        <label className="inline-block">
                                            <span className="px-4 py-2 bg-gray-100 rounded-lg cursor-pointer">
                                                Upload
                                            </span>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                multiple
                                                hidden
                                                onChange={(e) => readFileAsBase64(e.target.files)}
                                            />
                                        </label>

                                        <p className="text-xs text-gray-400 mt-2">
                                            You can upload up to 3 images
                                        </p>
                                    </div>

                                    {formData.images.length > 0 && (
                                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-4">
                                            {formData.images.map((img, index) => (
                                                <div key={index} className="relative group">
                                                    <img
                                                        src={img}
                                                        alt="preview"
                                                        className="h-32 w-full object-cover rounded-xl border"
                                                    />

                                                    {/* Remove button */}
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                images: prev.images.filter((_, i) => i !== index),
                                                            }))
                                                        }
                                                        className="absolute top-2 right-2 bg-black/70 text-white
                     rounded-full w-6 h-6 text-sm hidden group-hover:flex
                     items-center justify-center"
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    )}




                                    {/* Comments Section (only if comments exist) */}
                                    {formData.comments?.length > 0 && (
                                        <div className="mt-6 space-y-3">
                                            <h3 className="text-sm font-semibold text-gray-700">
                                                Comments ({formData.comments.length})
                                            </h3>

                                            <div className="max-h-56 overflow-y-auto space-y-3 pr-1">
                                                {formData.comments.map((comment) => {


                                                    return (
                                                        <div
                                                            key={comment._id}
                                                            className="bg-gray-50 border border-gray-200 rounded-xl p-4"
                                                        >
                                                            <p className="text-sm text-gray-800 leading-relaxed">
                                                                {comment.text}
                                                            </p>

                                                            <div className="flex justify-between items-center mt-2 text-xs text-gray-500">
                                                                <span>
                                                                    — {comment.startupId?.startupName || "User"}
                                                                </span>

                                                                <div className="flex items-center gap-3">
                                                                    <span>
                                                                        {moment(comment.createdAt).format("DD/MM/YYYY")}
                                                                    </span>

                                                                    {/* Remove button */}

                                                                    <button
                                                                        onClick={() => handleRemoveComment(comment._id, formData)}
                                                                        className="text-red-500 hover:text-red-600 font-medium"
                                                                    >
                                                                        Remove
                                                                    </button>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}


                                </div>

                                {/* Submit Button */}
                                <div className="mt-8 pt-6 border-t border-gray-100">
                                    <motion.button
                                        whileHover={!loader ? { scale: 1.02 } : {}}
                                        whileTap={!loader ? { scale: 0.98 } : {}}
                                        type="submit"
                                        disabled={loader}
                                        className={`w-full bg-gradient-to-r from-blue-600 to-purple-600
      text-white py-4 rounded-xl font-semibold text-lg
      flex items-center justify-center gap-3
      ${loader ? "opacity-70 cursor-not-allowed" : ""}`}
                                    >
                                        {loader ? (
                                            <>
                                                {/* Spinner */}
                                                <span className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                                                <span>Processing...</span>
                                            </>
                                        ) : (
                                            editIndex ? "Update Forum" : "Create Forum"
                                        )}
                                    </motion.button>
                                </div>

                            </form>

                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    )
}

export default AdminForum
